import { render, staticRenderFns } from "./SfOverlay.vue?vue&type=template&id=05a0e329&functional=true"
import script from "./SfOverlay.vue?vue&type=script&lang=js"
export * from "./SfOverlay.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./SfOverlay.vue?vue&type=style&index=0&id=05a0e329&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  injectStyles,
  null,
  "40a385c3"
  
)

export default component.exports